<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
    <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-data-table :headers="headers" :items="dashboardwithdraws" :items-per-page="4" :loading="isLoading"
        hide-default-footer disable-sort>
        <template v-slot:loading>
          <div class="d-flex align-center justify-center pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <span class="ml-2">Loading data...</span>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-information</v-icon>
            <span class="ml-2">No data found</span>
          </div>
        </template>
        <template v-slot:no-results>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-magnify</v-icon>
            <span class="ml-2">No matching data found</span>
          </div>
        </template>

        <template v-slot:item.admin_name="{ item }">
          {{ item?.admin_name || "N/A" }}
        </template>

        <template v-slot:item.created_at="{ item }">
          {{ formatMySQLDate(item?.created_at) }}
        </template>
        <template v-slot:item.name="{ item }">
          <router-link v-if="$canRoute('withdraw-requests') === 1" class="text-capitalize text--ash" :to="`/registered-user-details/${item?.cid}`">
            {{ item?.fname }} {{ item?.fname }}{{ " (" + item?.cid + ")" }}
          </router-link>
          <span v-else class="text-capitalize text--ash">{{ item?.fname }} {{ item?.fname }}{{ " (" + item?.cid + ")" }}</span>
        </template>

        <template v-slot:item.payment_system="{ item }">
          {{ item?.payment_system?.method_name || "N/A" }}
        </template>

        <template v-slot:item.email="{ item }">
          <v-tooltip top color="#000">
            <template v-slot:activator="{ on }">
              <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                {{ obfuscateAnyEmail(item?.email) }}
                <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                  {{
                    copiedStates[item.id] ? "mdi mdi-check" : "mdi-content-copy"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ item?.email }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.status="{ item }">
          <div class="status-selection">
            <v-select solo :items="updateslots"
              :append-icon="item.status === 1 ? 'mdi-checkbox-marked-circle' : item.status === 2 ? 'mdi-cancel' : 'mdi-chevron-down'"
              class="custom-select" v-model="item.status" item-text="statusText" item-value="status"
              :disabled="item.status > 0  && $canRoute('withdraw-requests') === 0 || $canRoute('withdraw-requests') === 2" @change="handleSelectChange(item)">
              <template v-slot:selection="{ item }">
                <div :class="getTextColor(item)">
                  {{
                    item.status === 0
                      ? "Pending"
                      : item.status === 1
                        ? "Approved"
                        : item.status === 2
                          ? "Rejected"
                          : null
                  }}
                </div>
              </template>
            </v-select>
          </div>
        </template>
        <!-- <template v-slot:item.details="{ item }">
          <v-icon color="#039de9" small> mdi-eye-outline </v-icon>
        </template> -->

        <template v-slot:item.details="{ item }">
          <v-dialog transition="scale-transition" origin="center center" max-width="985px"
            v-model="detailsDialog[item?.id]" content-class="deposit-modal" scrollable eager>
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex align-items-center">
                <div v-bind="attrs" v-on="on">
                  <v-icon color="#039de9" small @click="handleFile(item?.payment_slip)">
                    mdi-eye-outline
                  </v-icon>
                </div>
              </div>
            </template>

            <template>
              <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
                <v-btn class="close-btn" icon dark @click="handleClose(item)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-card-title>
                  <div class="image-details">
                    <v-img src="@/assets/bank-transfer.png"></v-img>
                    <h3>{{ item?.payment_system?.method_name }}</h3>
                  </div>
                  <div class="content-details">
                    <h3>Withdrawal:</h3>
                    <span>${{ item?.amount }}</span>
                  </div>
                </v-card-title>
                <div v-if="selectedFile">
                  <div class="img-center" v-if="isImage(item?.payment_slip)">
                    <img :src="item.payment_slip" class="modal-img"></img>
                  </div>
                  <div v-else-if="isPDF(item?.payment_slip)">
                    <iframe :src="item.payment_slip" width="100%" class="modal-iframe" height="250px" frameborder="0"></iframe>
                  </div>
                  <div v-else>
                    <p class="text-center">Unsupported file format.</p>
                  </div>
                </div>
                <div v-else>
                  <p class="text-center">
                    No document preview available.
                  </p>
                </div>
                <v-card-subtitle v-if="selectedFile">
                  <div class="download-icon cursor-pointer" @click="downloadFile(item?.payment_slip)">
                    <p>Download</p>
                    <v-icon small slot="append" color="#039de9">
                      mdi-tray-arrow-down
                    </v-icon>
                  </div>
                  <div class="tab-details cursor-pointer" @click="openInNewTab(item?.payment_slip)">
                    <p>Open In New Tab</p>
                    <v-icon small slot="append" color="#039de9">mdi-eye</v-icon>
                  </div>
                </v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <h1>All Information</h1>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Name</legend>
                        <v-text-field readonly :value="item?.fname + ' ' + item?.lname" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Email</legend>
                        <v-text-field readonly :value="item?.email" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Account No</legend>
                        <v-text-field readonly :value="item?.trading_account_no" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Transaction Method</legend>
                        <v-text-field readonly :value="item?.payment_system?.method_name
                          " single-line solo hide-details class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Transaction ID</legend>
                        <v-text-field readonly :value="item?.transaction_id || 'N/A'
                          " single-line solo hide-details class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Amount</legend>
                        <v-text-field readonly :value="item?.amount" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Trx. Fee</legend>
                        <v-text-field readonly :value="item?.trx_fee" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Net Amount</legend>
                        <v-text-field readonly :value="item?.net_amount" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Reference No.</legend>
                        <v-text-field readonly :value="item?.reference" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Time</legend>
                        <v-text-field readonly :value="item?.created_at" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Verification Image</legend>
                        <v-text-field readonly :value="item?.payment_slip" single-line solo hide-details
                          class="custom-select">
                          <v-icon small slot="append" color="#039de9" @click="
                            downloadFile(item?.payment_slip)
                            ">
                            mdi-tray-arrow-down
                          </v-icon></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <fieldset>
                        <legend>Status</legend>
                        <v-text-field readonly :value="item?.status === 0
                          ? 'Pending'
                          : item?.status === 1
                            ? 'Approved'
                            : 'Rejected'
                          " single-line solo hide-details class="custom-select">
                          <v-icon small slot="prepend" color="#FFC020">
                            mdi-star-outline
                          </v-icon></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12">
                      <fieldset>
                        <legend>Remarks</legend>
                        <v-text-field readonly :value="item?.remarks" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                  </v-row>

                  <v-row v-if="item?.status === 0">
                    <v-col cols="12">
                      <h3 class="text-success">Upload A Pay Slip</h3>
                    </v-col>
                    <v-col cols="12">
                      <fieldset>
                        <legend>Proof</legend>
                        <v-file-input v-model="pay_slip" label="Choose file in needed (Max Size 2MB)" single-line solo
                          prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange"></v-file-input>
                      </fieldset>
                      <v-img v-if="previewUrl" class="img-logo-bank" :src="previewUrl"></v-img>
                      <span v-if="errors.pay_slip" class="error-message">{{ errors.pay_slip }}</span>
                    </v-col>
                  </v-row>

                  <v-row v-if="isItOpen(item)">
                    <v-col cols="6">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                          color="greenMain" :disabled="isApproving || item?.status === 1  || $canRoute('withdraw-requests') === 0 || $canRoute('withdraw-requests') === 2"
                          @click="handleWithdrawApprove(item)">
                          <v-progress-circular v-if="isApproving" indeterminate size="16" width="2" color="white"
                            class="mr-2"></v-progress-circular>
                          {{ item?.status === 1 ? "Approved" : (isApproving ? "Approving..." : "Approve") }}
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                          color="#FF567F" :disabled="item?.status === 1 || isApproving  || $canRoute('withdraw-requests') === 0 || $canRoute('withdraw-requests') === 2"
                          @click="handleOpenRejectDialog()">
                          Rejected
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="
                    item?.status === 2 ||
                    showRejectionCauseSection
                  ">
                    <v-col cols="12">
                      <h2>Rejection Cause</h2>
                    </v-col>
                    <v-col cols="12" v-if="item?.status !== 2">
                      <fieldset>
                        <legend>Reason</legend>
                        <v-select v-model="selectedReason" solo :items="slots5" append-icon="mdi-chevron-down"
                          label="Click to select" class="custom-select" hide-details></v-select>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" v-if="
                      item?.status === 2 ||
                      selectedReason === 'Other'
                    ">
                      <fieldset>
                        <legend>
                          {{
                            item?.status === 2
                              ? "Reason"
                              : "Write Your Reason"
                          }}
                        </legend>
                        <v-text-field :disabled="item?.status === 2" v-model="reason" single-line :label="item?.status === 2
                          ? item?.reason
                          : 'Write here'
                          " solo hide-details class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="6" v-if="item?.status !== 2">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                          color="#FF567F" :disabled="isRejecting" @click="handleRejectWithdraw(item)">
                          <v-progress-circular v-if="isRejecting" indeterminate size="16" width="2" color="white"
                            class="mr-2"></v-progress-circular>
                          {{ isRejecting ? "Rejecting..." : "Confirm Reject" }}
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="6" v-if="item?.status !== 2">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" block outlined class="ma-0 text-capitalize btn-account py-4"
                          @click="handleCloseRejectDialog()">
                          Cancel
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
        </template>


      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { PARTNERWITHDRAW__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      errors: {
        pay_slip: ""
      },
      pay_slip: null,
      previewUrl: null,
      search: "",
      searchTimeout: null,
      isApproving: false,
      isRejecting: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      selectedStatus: "",
      seletedDropdownTrx: "",
      seletedDropdownStatus: "",
      selectedDates: [],
      selectedDatesText: null,
      isCopied: false,
      copiedStates: {},
      modal: false,
      dialog: false,
      reason: null,
      remarks: null,
      showButtons: true,
      selectedReason: null,
      detailsDialog: {},
      selectedFile: null,
      showRejectionCauseSection: false,
      slots5: [
        "Deposit and withdrawal method must be same",
        "Not enough balance",
        "Can't transfer funds to third party accounts",
        "Any fraudulent activity we must suspend the principal account until investigation of compliance",
        "Other",
      ],
      date: ["2022-01-01", "2023-01-01"],
      updateslots: [
        { status: 0, statusText: "Pending" },
        { status: 1, statusText: "Approved" },
        { status: 2, statusText: "Rejected" },
      ],
      headers: [
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Amount", value: "amount" },
        { text: "Trx Method", value: "payment_system" },
        { text: "Action By", value: "admin_name" },
        { text: "Status", value: "status" },
        { text: "Details", value: "details" },
      ],
    };
  },
  computed: {
    ...mapState("partnerwithdraw", ["dashboardwithdraws", "isLoading"]),
    ...mapState("admins", ["loggedAdmin"]),

    isItOpen() {
      return function (item) {
        return item?.status !== 2;
      };
    },

    allStatus() {
      return [
        {
          id: -1,
          value: -1,
          text: "All",
        },
        {
          id: 9,
          value: 0,
          text: "Pending",
        },
        {
          id: 10,
          value: 1,
          text: "Approved",
        },
        {
          id: 11,
          value: 2,
          text: "Rejected",
        },
      ];
    },
  },
  methods: {
    formatMySQLDate,
    ...mapActions("partnerwithdraw", [
      PARTNERWITHDRAW__ACTIONS.DASHBOARDPARTNERWITHDRAW,
      PARTNERWITHDRAW__ACTIONS.CHANGESTATUS,
    ]),

    isImage(url) {
      return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);
    },

    isPDF(url) {
      return /\.pdf$/i.test(url);
    },

    onFileChange(file) {
      if (file && file.size < 2000000) {
        this.pay_slip = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.pay_slip = null;
        this.previewUrl = null;
        this.errors.pay_slip = "File size should be less than 2MB";
      }
    },

    handleStatusChange() {
      let startDate, endDate;
      const parameter = {};

      if (this.seletedDropdownTrx) {
        parameter.payment_system_id =
          this.seletedDropdownTrx > 0 ? this.seletedDropdownTrx : null;
      }

      parameter.status =
        this.seletedDropdownStatus === -1
          ? null
          : !this.seletedDropdownStatus
            ? 0
            : this.seletedDropdownStatus;

      if (this.selectedDates[0] && this.selectedDates[1]) {
        startDate = new Date(this.selectedDates[0]);
        endDate = new Date(this.selectedDates[1]);
        if (startDate && endDate && startDate > endDate) {
          [startDate, endDate] = [endDate, startDate];
        }
        if (startDate && endDate) {
          const duration = `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
            }`;
          parameter.duration = duration;
        }
      }

      this[PARTNERWITHDRAW__ACTIONS.DASHBOARDPARTNERWITHDRAW](parameter);
    },

    handleFile(item) {
      this.selectedFile = item;
      this.pay_slip = null;
      this.previewUrl = null;
    },

    handleClose(item) {
      this.$set(this.detailsDialog, item?.id, false);
      this.previewUrl = null;
      this.pay_slip = null;
    },

    downloadFile(fileUrl) {
      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = true;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    openInNewTab(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    async handleWithdrawApprove(item) {
      try {
        this.isApproving = true;

        const formData = new FormData();
        formData.append("id", item?.id);
        formData.append("status", 1);
        formData.append("remarks", this.remarks || "N/A");

        if (this.pay_slip) {
          formData.append("payment_slip", this.pay_slip);
        }

        await this[PARTNERWITHDRAW__ACTIONS.CHANGESTATUS](formData);
        this.pay_slip = null;
        this.previewUrl = null;
        this.remarks = "";
      } catch (error) {
        console.error("Error approving withdrawal:", error);
      } finally {
        this.isApproving = false;
      }
    },

    handleOpenRejectDialog() {
      this.showRejectionCauseSection = true;
      this.showButtons = false;
    },

    handleCloseRejectDialog() {
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
    },

    async handleRejectWithdraw(item) {
      try {
        this.isRejecting = true;
        const formData = new FormData();
        formData.append("id", item?.id);
        formData.append("status", 2);
        formData.append("reason", this.reason || this.selectedReason || "N/A");

        if (this.pay_slip) {
          formData.append("payment_slip", this.pay_slip);
        }

        await this[PARTNERWITHDRAW__ACTIONS.CHANGESTATUS](formData);
        this.showRejectionCauseSection = false;
        this.showButtons = true;
        this.selectedReason = null;
        this.reason = null;
      } catch (error) {
        console.error("Error rejecting withdrawal:", error);
      } finally {
        this.isRejecting = false;
      }
    },

    handleTrxMethodChange() {
      let startDate, endDate;
      const parameter = {};

      parameter.payment_system_id =
        this.seletedDropdownTrx > 0 ? this.seletedDropdownTrx : null;

      if (this.seletedDropdownStatus) {
        parameter.status =
          this.seletedDropdownStatus === -1
            ? null
            : !this.seletedDropdownStatus
              ? 0
              : this.seletedDropdownStatus;
      }

      if (this.selectedDates[0] && this.selectedDates[1]) {
        startDate = new Date(this.selectedDates[0]);
        endDate = new Date(this.selectedDates[1]);
        if (startDate && endDate && startDate > endDate) {
          [startDate, endDate] = [endDate, startDate];
        }
        if (startDate && endDate) {
          const duration = `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
            }`;
          parameter.duration = duration;
        }
      }

      this[PARTNERWITHDRAW__ACTIONS.DASHBOARDPARTNERWITHDRAW](parameter);
    },

    handleSelectChange(item) {
      this.selectedStatus = item.status;

      const parameter = {
        id: item?.id,
        status: item?.status,
      };
      this[PARTNERWITHDRAW__ACTIONS.CHANGESTATUS](parameter);
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
    copyText(item) {
      navigator.clipboard.writeText(item.account.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    getColor(item) {
      return item.color;
    },

    getTextColor(item) {
      return item.status === 1
        ? "text-approved"
        : item.status === 2
          ? "text-decline"
          : "text-pending";
    },

    cancelSelection() {
      this.modal = false;
    },

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        console.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        duration: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`,
      };

      if (this.seletedDropdownStatus) {
        parameter.status =
          this.seletedDropdownStatus === -1
            ? null
            : !this.seletedDropdownStatus
              ? 0
              : this.seletedDropdownStatus;
      }

      if (this.seletedDropdownTrx) {
        parameter.payment_system_id =
          this.seletedDropdownTrx > 0 ? this.seletedDropdownTrx : null;
      }

      this[PARTNERWITHDRAW__ACTIONS.DASHBOARDPARTNERWITHDRAW](parameter);

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },
  },
  async mounted() {
    this[PARTNERWITHDRAW__ACTIONS.DASHBOARDPARTNERWITHDRAW]();
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>

<style>
.modal-img{
  width: auto;
  height: 250px;
}

.img-center{
  text-align: center;
  width: 100%;
}
</style>
